module.exports = __webpack_public_path__ + "img/download-phones-de.849aa89.png";